import type { QuoteTag, OptionsDocument } from 'paintscout'
import { updateQuoteTag } from './update-quote-tag'

export function bulkUpdateQuoteTags(newTags: QuoteTag[], options: OptionsDocument, index = 0): OptionsDocument {
  const updatedOptions = updateQuoteTag({ quoteTag: newTags[index], options })
  if (newTags[index + 1] !== undefined) {
    return bulkUpdateQuoteTags(newTags, updatedOptions, index + 1)
  }
  return updatedOptions
}
